/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_EmptyInputs */

const cs_portals_sync_empty = /** @type {(inputs: Portals_Sync_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné exporty — zapněte portál níže.`)
};

const en_portals_sync_empty = /** @type {(inputs: Portals_Sync_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No portal export rows yet — enable a portal below.`)
};

/**
* | output |
* | --- |
* | "No portal export rows yet — enable a portal below." |
*
* @param {Portals_Sync_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_empty = /** @type {((inputs?: Portals_Sync_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_empty(inputs)
	return cs_portals_sync_empty(inputs)
});